import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { ImageCroppingPresets } from '../../../modules/Media/MediaUtils';
import { SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledImg, StyledP } from '../../../styles/StyledHTML';
import { Theme } from '../../../styles/Theme';
import { searchAlbum } from '../../modules/Album/redux/album.actions';
import { AssetCard, useAsset, useAssetMedia } from '../../modules/Assets/AssetCard';
import { searchAssets } from '../../modules/Assets/redux/assets.actions';
import { FullAssets } from '../../modules/Assets/redux/assets.selectors';
import placeholderImage from '../../../assets/placeholder-square.jpg';

const StyledContentCardWrap = styled(SmartContainer)`
     border: ${Theme.borderWidth} solid rgba(0,0,0,0);
     background: ${Theme.colors.baseAlternate};
     border-radius: ${Theme.radius};
     padding: 0.75em;
     width: 100%;
     [data-title]{
        margin-top: 1em;
        font-size: 0.75em;
        font-weight: ${Theme.CaptureCollabStyles.fonts.headingWeight};
     }
     [data-cover]{
        &:after { display: none; }
     }
     transition: ${Theme.transition.one};
     transform: translate3d(0,0,0);
     box-shadow: ${Theme.shadow.none};
     &:hover {
        border: ${Theme.borderWidth} solid ${Theme.colors.dark};
        box-shadow: ${Theme.shadow.three};
        transform: translate3d(-5px,-5px,0);
     }
`


const StyledCoverPhoto = styled(SmartContainer)`
    position: relative;
    background-color: ${Theme.colors.dark};
    border-radius: ${Theme.radiusSmall};
    width: 100%;
    min-height: 200px;
    aspect-ratio: 1 / 1;
    border: 1px solid ${Theme.colors.dark};
    [data-content]{
        position: absolute;
        padding: 1em;
        bottom: 0em;
        width: 100%;
        color: white;
        z-index: 2;
    }
    ${props => (props.withCoverPhoto === true) ? css`
        &:after {
            content:"";
            position: absolute;
            width: 100%;
            height: 100%;
            bottom: 0;
            left: 0;
            background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
            border-radius: ${Theme.radius};
            z-index: 1;
        }

    ` : ''}

`



export const DefaultContentCard = ({ content, onClick, filters, model = null, noImage = false }) => {

    const dispatch = useDispatch();
    const storeAssets = FullAssets();
    const item = (content?.full) ? content.full : content;
    const [coverPhoto, setCoverPhoto] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [bgImage, setBgImage] = useState('');

    const { assetPath, setAssetId } = useAssetMedia({ args: ImageCroppingPresets.preview });

    useEffect(() => {

        const m = (content?.full) ? content.full : content;
        if (m?.coverPhotoId) {
            setCoverPhoto(m.coverPhotoId);
            setLoaded(true);
        }
        else if (m?.meta?.coverPhoto) {
            setCoverPhoto(m?.meta?.coverPhoto);
            setLoaded(true);
        }
        // Get Latest As Cover
        // Comment out to remove dynamic cover
        // else {
        //     const args = { ...filters }
        //     args['prefix'] = m.id;
        //     args[model] = `["${m?.id}"]`
        //     dispatch(searchAssets(0, 1, null, 'all', args))
        // }


    }, [content?.full ? content.full.id : content.id])

    useEffect(() => {
        if (noImage === true) return;
        if (!storeAssets[item?.id]?.rows) return;
        const latestAsset = (storeAssets[item?.id]?.rows[0]) ? storeAssets[item?.id]?.rows[0] : null;
        if (!latestAsset) return false;
        if (!latestAsset?.meta?.MediaId) return false;
        // Set The Cover Photo
        setCoverPhoto(latestAsset?.id);
        setLoaded(true);
    }, [storeAssets[item?.id]])

    useEffect(() => {
        if (!coverPhoto) return;
        setAssetId(coverPhoto);
    }, [coverPhoto])

    const hasCover = true; //(coverPhoto) ? true : false;

    // Overlay
    // return (
    //     <StyledContentCardWrap>
    //         <StyledCoverPhoto withCoverPhoto={hasCover} background={`url("${assetPath}")`} clickable width="100%" onClick={() => onClick(item)}>
    //             {/* {coverPhoto && (<AssetCard id={coverPhoto} crop={ImageCroppingPresets.thumbnail} />)} */}
    //             {/* {!coverPhoto && (<StyledImg radius src={placeholderImage} />)} */}
    //             {/* <AssetCard id={coverPhoto} crop={ImageCroppingPresets.thumbnail} noControls={true} /> */}
    //             <SmartContainer data-content>
    //                 <StyledP>{item?.name}</StyledP>
    //             </SmartContainer>

    //         </StyledCoverPhoto>

    //     </StyledContentCardWrap>
    // )
    // return (
    //     <Stack clickable width="100%" onClick={() => onClick(item)}>
    //         {/* {!coverPhoto && (<StyledImg radius src={placeholderImage} />)} */}
    //         <AssetCard id={coverPhoto} crop={ImageCroppingPresets.thumbnail} noControls={true} />
    //         <SmartContainer data-content>
    //             <StyledP light>{item?.name}</StyledP>
    //         </SmartContainer>
    //     </Stack>
    // )
    return (
        <StyledContentCardWrap onClick={() => onClick(item)} clickable>
            <StyledCoverPhoto data-cover withCoverPhoto={hasCover} background={`url("${assetPath}")`} clickable width="100%" />
            <SmartContainer data-title>
                <StyledP>{item?.name}</StyledP>
            </SmartContainer>
        </StyledContentCardWrap>
    )
}